<template>
    <div id="app">
        <!-- 排序控制区 -->
        <div class="sort-controls">
            <!-- <button @click="sortByAmount" :class="{ active: sortBy === 'amount' }">
                按业绩金额
            </button> -->
            <span style="font-size: 15px;">时间: {{ startDate + '至' + endDate }}</span>
        </div>
        <!-- 业绩榜单 -->
        <div class="performance-ranking">
            <h2>金额排名</h2>
            <table>
                <thead>
                    <tr>
                        <th>排名</th>
                        <th v-for="(item, index) in columns" :key="index">{{ item.name }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in filteredItems" :key="item.id">
                        <td>{{ index + 1 }}</td>
                        <td v-for="value in columns">{{ formatCurrency(item[value.key],value.boolean) }}</td>
                        <!-- <td>{{ item.name }}</td>
                        <td>{{ formatCurrency(item.amount) }}</td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Ranking',
    props: {
        items: {
            type: Array,
            default: () => ([])
        },
        columns: {
            type: Array,
            default: () => ([])
        },
        startDate: {
            type: String,
            default: ''
        },
        endDate: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            sortBy: 'amount',
            ascending: true,
            searchQuery: ''
        };
    },
    computed: {
        filteredItems() {
            const searchLower = this.searchQuery.toLowerCase();
            let filtered = this.items;

            if (searchLower) {
                filtered = filtered.filter(item =>
                    item.name.toLowerCase().includes(searchLower) ||
                    item.department.toLowerCase().includes(searchLower)
                );
            }

            // 排序逻辑
            return [...filtered].sort((a, b) => {
                let modifier = this.ascending ? 1 : -1;

                if (this.sortBy === 'amount') {
                    return modifier * (b.amount - a.amount);
                } else if (this.sortBy === 'growthRate') {
                    return modifier * (b.growthRate - a.growthRate);
                } else if (this.sortBy === 'name') {
                    return modifier * a.name.localeCompare(b.name);
                }
                return 0;
            });
        },
        totalAmount() {
            return this.items.reduce((sum, item) => sum + item.amount, 0);
        },
        avgAmountPerUser() {
            return this.items.length > 0
                ? this.formatCurrency(this.totalAmount / this.items.length)
                : '¥0';
        },
        avgGrowthRate() {
            return this.items.length > 0
                ? (this.items.reduce((sum, item) => sum + parseFloat(item.growthRate), 0) / this.items.length).toFixed(1)
                : '0.0';
        },
        topThree() {
            return [...this.items].sort((a, b) => b.amount - a.amount).slice(0, 3);
        },
        orderIcon() {
            return this.ascending ? 'fa-sort-amount-down-alt' : 'fa-sort-amount-down';
        },
        orderLabel() {
            return this.ascending ? '升序' : '降序';
        }
    },
    methods: {
        formatCurrency(value,key) {
            if(key === true) {
                return '¥' + value.toLocaleString();
            }
            return value;
        },
        sortByAmount() {
            this.sortBy = 'amount';
        },
        sortByGrowthRate() {
            this.sortBy = 'growthRate';
        },
        sortByName() {
            this.sortBy = 'name';
        },
        toggleOrder() {
            this.ascending = !this.ascending;
        },
        getGrowthClass(growthRate) {
            return {
                'positive': growthRate > 0,
                'negative': growthRate < 0
            };
        },
    },
    created() {
    }
};
</script>

<style scoped>
#app {
    font-family: 'Arial', sans-serif;
    max-width: 1200px;

    padding: 20px;
}

.search-container {
    margin-bottom: 20px;
}

.search-input {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 16px;
    box-sizing: border-box;
}

.sort-controls {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.sort-controls button {
    padding: 8px 15px;
    background: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s;
}

.sort-controls button:hover {
    background: #e0e0e0;
}

.sort-controls button.active {
    background: #409eff;
    color: white;
    border-color: #409eff;
}

.order-toggle {
    display: flex;
    align-items: center;
    gap: 5px;
}

.kpi-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 30px;
    gap: 20px;
}

.kpi-card {
    flex: 1;
    padding: 20px;
    background: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    text-align: center;
}

.kpi-card h3 {
    margin-top: 0;
    color: #666;
    font-size: 16px;
}

.kpi-card p {
    font-size: 24px;
    font-weight: bold;
    margin: 10px 0 0;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 30px;
}

table th,
table td {
    padding: 12px 15px;
    text-align: left;
    border-bottom: 1px solid #eee;
}

table th {
    background-color: #f5f7fa;
    font-weight: 600;
}

.positive {
    color: #67c23a;
    font-weight: bold;
}

.negative {
    color: #f56c6c;
    font-weight: bold;
}

.up {
    color: #67c23a;
    font-weight: bold;
}

.down {
    color: #f56c6c;
    font-weight: bold;
}

.top-performers {
    margin-top: 40px;
}

.top-cards {
    display: flex;
    gap: 20px;
}

.top-card {
    flex: 1;
    display: flex;
    border: 1px solid #eaeaea;
    border-radius: 8px;
    padding: 15px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    position: relative;
}

.medal {
    width: 40px;
    height: 40px;
    background: gold;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
    margin-right: 15px;
}

.top-card:nth-child(2) .medal {
    background: silver;
}

.top-card:nth-child(3) .medal {
    background: #cd7f32;
    /* bronze */
}

.employee-info {
    flex-grow: 1;
}

.employee-name {
    font-weight: bold;
    font-size: 18px;
}

.employee-department {
    color: #666;
    font-size: 14px;
}

.employee-stats {
    text-align: right;
}

.stat-amount {
    font-weight: bold;
    font-size: 16px;
}

.stat-growth {
    font-size: 14px;
}
</style>